module.exports = __webpack_public_path__ + "static/media/2.0d4adcb4.png";